import {
  SERVICE_LINKS,
} from '@/store/ServiceRegistry/linkedservices'

import {
  BASE_URL,
} from '@/store/ServiceRegistry/services'

export const PLUGIN_INTERFACE_TYPES = {
  SYS_ADMIN: 'admin',
}

const RESET = 'RESET'
const SET_ACTIVE_PLUGINS = 'SET_ACTIVE_PLUGINS'

const PROXY_URL = (serviceId) => {
  let proxyUrl = `${BASE_URL}/ExecuteProxy/${serviceId}`
  return (subpath) => `${proxyUrl}/${subpath}`
}

// TODO: In future when fetching UI through plugin
// create endpoint to fetch plugin interfaces and UI component resources
const pluginDefinitions = [{
  interfaces: {
    [PLUGIN_INTERFACE_TYPES.SYS_ADMIN]: {
      linkName: 'Equipment Tracker',
      pageTitle: 'Manage Equipment',
      description: 'Say something here about equipment management, adding removing, tracking, various sites it can be installed at',
      icon: 'dns',
      noPadding: true,
      component: () => import('@/components/Manage/Plugins/EquipmentPlugin/systemAdmin/App'),
    },
  },
  service: {
    serviceLink: SERVICE_LINKS.EQUIPMENT_TRACKER,
    id: 'e92d09d6-556b-4cdc-8c3a-2bb5231da75d',
  },
}, {
  interfaces: {
    [PLUGIN_INTERFACE_TYPES.SYS_ADMIN]: {
      linkName: 'Hatfield Discrete Data Importer',
      pageTitle: 'Hatfield Discrete Data Importer Configuration',
      description: 'Configure how raw discrete chemistry sample data is imported into EnviroData for each report type',
      icon: 'dns',
      noPadding: true,
      component: () => import('@/components/Manage/Plugins/HatfieldEdd/App'),
    },
  },
  service: {
    serviceLink: SERVICE_LINKS.HATFIELD_EDD_INGESTION,
    id: '9d8214d9-0d50-4c88-b9c1-d16a7ddbc71e',
  },
}]

let initialState = () => ({
  initializedPlugins: {},
  activePlugins: [],
})

export default {
  namespaced: true,
  state: initialState,
  actions: {
    async getActivePlugins({ commit, dispatch }) {
      let serviceIds = pluginDefinitions.map(plugin => plugin.service.id)
      let pingResult
      try {
        pingResult = await dispatch('services/pingServices', { serviceIds: serviceIds }, { root: true })
      } catch (error) {
        pingResult = []
      }

      let activeServiceIds = pingResult.filter(res => res.Active).map(res => res.ServiceId)
      let activePlugins = pluginDefinitions.filter(plugin => activeServiceIds.includes(plugin.service.id))
      activePlugins.forEach(activePlugin => {
        activePlugin.service.proxyUrlMaker = PROXY_URL(activePlugin.service.id)
      })
      commit(SET_ACTIVE_PLUGINS, activePlugins)
    },
  },
  mutations: {
    [SET_ACTIVE_PLUGINS](state, activePlugins) {
      state.activePlugins = activePlugins
    },
    [RESET](state) {
      const s = initialState()
      Object.keys(s).forEach(key => {
        state[key] = s[key]
      })
    },
  },
  getters: {
    activePluginByServiceId: (state) => serviceId => state.activePlugins.find(plugin => plugin.service.id === serviceId),
    activePluginByServiceLink: (state) => serviceLink => state.activePlugins.find(plugin => plugin.service.serviceLink == serviceLink),
  },
}